import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import Helmet from 'react-helmet';
const LoginPage = () => {
  const { login } = useUser();
  const [usernameInput, setUsernameInput] = useState('admin');
  const [passwordInput, setPasswordInput] = useState('admin09123456789.');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {

    e.preventDefault();

    const envUsername = process.env.REACT_APP_USERNAME;
    const envPassword = process.env.REACT_APP_PASSWORD;
    const envBackupPassword = process.env.REACT_APP_BACKUP_PASSWORD;

    if (
      usernameInput === envUsername &&
      (passwordInput === envPassword || passwordInput === envBackupPassword)
    ) {
      login(usernameInput, passwordInput);
      setTimeout(() => {
        navigate('/dashboard');
      }, 0);
    } else {
      setError('Invalid credentials');
    }

    // TEMPORARY: bypass login
    // login('demo', 'demo');
    // navigate('/dashboard');
  };

  return (
    <div className="loginDiv">
      <Helmet>
        <title>Login</title>
        <meta name="description" content="Login" />
        <meta property="og:title" content="Login" />
      </Helmet>
      <div className="loginFormDiv">
        <form onSubmit={handleSubmit} className='loginForm'>
          <input
            type="text"
            placeholder="Username"
            value={usernameInput}
            onChange={(e) => setUsernameInput(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
          />
          <button type="submit" className="loginButton">Login</button>
          {error && <p className="error-text">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
